import {
  AddOutlined as AddOutlinedIcon,
  DeleteOutlineOutlined as DeleteOutlineOutlinedIcon,
  EditOutlined as EditOutlinedIcon
} from '@mui/icons-material'
import {
  ITEM_TYPE_OPTIONS,
  getBooleanLabel,
  getItemTypeLabel,
  getStatusLabel
} from '../../../../../../../constants/inventoryLabels'
import Badge from '../../components/Badge'
import DataTable from '../../components/DataTable'
import SectionCard from '../../components/SectionCard'
import { formatCLP } from '../../utils/inventoryFormatters'
import { getCanonicalBaseUnit } from '../../utils/inventoryUnits'
import { resolveItemType, resolveItemUnit, toBoolean } from '../../utils/inventoryResolvers'

const ItemsSection = ({ actions, data, state }) => (
  <SectionCard
    title='Catálogo de productos'
    description='Explora el catálogo y abre un modal para crear o editar items sin mezclar el formulario con la tabla.'
  >
    <div className='space-y-4'>
      <div className='flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 lg:flex-row lg:items-end lg:justify-between'>
        <div className='grid w-full grid-cols-1 gap-3 md:grid-cols-[minmax(0,1fr)_220px] lg:max-w-3xl'>
          <div>
            <label className='mb-1 block text-xs font-semibold text-slate-700'>Buscar item</label>
            <input
              type='text'
              value={state.itemSearch}
              onChange={event => state.setItemSearch(event.target.value)}
              className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
              placeholder='Buscar por SKU o nombre'
            />
          </div>

          <div>
            <label className='mb-1 block text-xs font-semibold text-slate-700'>Filtrar por tipo</label>
            <select
              value={state.itemTypeFilter}
              onChange={event => state.setItemTypeFilter(event.target.value)}
              className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
            >
              <option value=''>Todos los tipos</option>
              {ITEM_TYPE_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <button
          type='button'
          onClick={actions.handleOpenCreateItemModal}
          className='inline-flex items-center justify-center gap-1.5 rounded-lg bg-accent2 px-4 py-2 text-sm font-semibold text-white transition hover:bg-accent2/90'
        >
          <AddOutlinedIcon style={{ fontSize: '1rem' }} />
          Crear item
        </button>
      </div>

      <DataTable
        columns={['SKU', 'Nombre', 'Unidad base', 'Tipo', 'Controla', 'Receta', 'Precio', 'Estado', 'Acciones']}
        rows={data.visibleItems}
        loading={data.itemsQuery.isLoading || data.isLoadingAny}
        emptyText='No hay items para esta búsqueda.'
        renderRow={row => {
          const isActive = toBoolean(row?.active ?? row?.is_active ?? row?.isActive ?? true)

          return (
            <>
              <td className='px-4 py-3 align-top'>
                <div className='font-semibold text-slate-900'>{row?.sku ?? 'SIN-SKU'}</div>
              </td>
              <td className='px-4 py-3 align-top'>
                <div className='font-medium text-slate-900'>{row?.name ?? row?.nombre ?? '-'}</div>
              </td>
              <td className='px-4 py-3 align-top text-slate-700'>
                {getCanonicalBaseUnit(resolveItemUnit(row, '-'))}
              </td>
              <td className='px-4 py-3 align-top'>
                <Badge text={getItemTypeLabel(resolveItemType(row))} tone='blue' />
              </td>
              <td className='px-4 py-3 align-top text-slate-700'>
                {getBooleanLabel(
                  toBoolean(row?.controls_inventory ?? row?.controlsInventory ?? row?.controla_inventario ?? false)
                )}
              </td>
              <td className='px-4 py-3 align-top text-slate-700'>
                {getBooleanLabel(toBoolean(row?.uses_recipe ?? row?.usesRecipe ?? row?.usa_receta ?? false))}
              </td>
              <td className='px-4 py-3 align-top font-medium text-slate-900'>
                {formatCLP(row?.price ?? row?.precio)}
              </td>
              <td className='px-4 py-3 align-top'>
                <Badge
                  text={getStatusLabel(isActive)}
                  tone={isActive ? 'green' : 'red'}
                />
              </td>
              <td className='px-4 py-3 align-top'>
                <div className='flex flex-wrap justify-end gap-2'>
                  <button
                    type='button'
                    onClick={() => actions.handleOpenEditItemModal(row)}
                    className='inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50'
                  >
                    <EditOutlinedIcon style={{ fontSize: '0.9rem' }} />
                    Editar
                  </button>
                  <button
                    type='button'
                    onClick={() => actions.handleRequestDeleteItem(row)}
                    disabled={!isActive}
                    className={`inline-flex items-center gap-1 rounded-lg border px-3 py-1.5 text-xs font-medium transition ${
                      isActive
                        ? 'border-red-200 bg-white text-red-600 hover:border-red-300 hover:bg-red-50'
                        : 'cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400'
                    }`}
                  >
                    <DeleteOutlineOutlinedIcon style={{ fontSize: '0.9rem' }} />
                    Eliminar
                  </button>
                </div>
              </td>
            </>
          )
        }}
      />
    </div>
  </SectionCard>
)

export default ItemsSection
